import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import moment from 'moment';
import Form from '../../components/Form/Form';
import { ROLE_PHYSICIAN } from '../../constants/roles';

const fields = [
  {
    id: 'firstName',
    name: 'firstName',
    label: 'First Name',
    type: 'text',
    validateAs: 'string',
    defaultVal: '',
    required: true,
  },
  {
    id: 'lastName',
    name: 'lastName',
    label: 'Last Name',
    type: 'text',
    validateAs: 'string',
    defaultVal: '',
    required: true,
  },
  {
    id: 'email',
    name: 'email',
    label: 'Email',
    type: 'email',
    validateAs: 'string',
    defaultVal: '',
    disabled: true,
    required: true,
  },
  {
    id: 'dateJoined',
    name: 'dateJoined',
    label: 'Date Joined',
    type: 'text',
    validateAs: 'string',
    defaultVal: '',
    disabled: true,
    required: true,
  },
];

const extraFields = [
  {
    id: 'optionalEmail1',
    name: 'optionalEmail1',
    label: 'Optional Email 1',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail2',
    name: 'optionalEmail2',
    label: 'Optional Email 2',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail3',
    name: 'optionalEmail3',
    label: 'Optional Email 3',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail4',
    name: 'optionalEmail4',
    label: 'Optional Email 4',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
  {
    id: 'optionalEmail5',
    name: 'optionalEmail5',
    label: 'Optional Email 5',
    type: 'email',
    validateAs: 'email',
    defaultVal: '',
    required: false,
  },
];

const propTypes = {
  authStore: mobxPropTypes.observableObject.isRequired,
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const populateFields = (user, fieldsList) => {
  const data = {
    firstName: { defaultVal: user.first_name },
    lastName: { defaultVal: user.last_name },
    email: { defaultVal: user.email },
    dateJoined: { defaultVal: moment(user.date_joined).format('YYYY-MM-DD') },
    optionalEmail1: { defaultVal: user.optional_email_one || '' },
    optionalEmail2: { defaultVal: user.optional_email_two || '' },
    optionalEmail3: { defaultVal: user.optional_email_three || '' },
    optionalEmail4: { defaultVal: user.optional_email_four || '' },
    optionalEmail5: { defaultVal: user.optional_email_five || '' },
  };

  const populatedFileds = fieldsList.map(field => (
    { ...field, ...data[field.name] }
  ));
  return populatedFileds;
};

const ProfileForm = ({ authStore, user }) => {
  let elements = fields;
  if (user.role === ROLE_PHYSICIAN) {
    elements = fields.concat(extraFields);
  }
  return (
    <Form
      fields={populateFields(user, elements)}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await authStore.updateProfile(user.id, values);
          setSubmitting(false);
        } catch (e) {
          setSubmitting(false);
        }
      }}
      submitLabel="Submit"
      columns={2}
      spacing={32}
    />
  );
};


ProfileForm.propTypes = propTypes;
export default inject('authStore')(observer(ProfileForm));



// WEBPACK FOOTER //
// ./src/containers/ProfileForm/ProfileForm.js